import { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

import NumberLotteryPicker from '../components/NumberLotteryPicker.vue'
import NumberLotteryXsAndOsPicker from '../components/NumberLotteryXsAndOsPicker.vue'

export type NumberLotteryPickerComponent = typeof NumberLotteryPicker

export const NUMBER_LOTTERY_DEFAULT_PICKER: NumberLotteryPickerComponent = NumberLotteryPicker

export const NUMBER_LOTTERY_PICKER_BY_LOTTERY: Partial<
  Record<LotteryId, NumberLotteryPickerComponent>
> = {
  [LotteryId.PowerBallXsAndOs]: NumberLotteryXsAndOsPicker,
}
